import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";

const WarrantyTab = ({ selectedUser, onChange, onSave }) => {
  // Warranty access controls
  const [warrantyEnabled, setWarrantyEnabled] = useState(false);
  const [canSubmitWarranty, setCanSubmitWarranty] = useState(false);
  const [canApproveRejectWarranty, setCanApproveRejectWarranty] =
    useState(false);

  useEffect(() => {
    // Initialize warranty access controls
    if (selectedUser) {
      setWarrantyEnabled(selectedUser?.warrantyEnabled ?? false);
      setCanSubmitWarranty(selectedUser?.canSubmitWarranty ?? false);
      setCanApproveRejectWarranty(
        selectedUser?.canApproveRejectWarranty ?? false
      );
    }
  }, [selectedUser]);

  // Notify parent component of changes
  useEffect(() => {
    if (onChange) {
      onChange({
        warrantyEnabled,
        canSubmitWarranty,
        canApproveRejectWarranty,
      });
    }
  }, [warrantyEnabled, canSubmitWarranty, canApproveRejectWarranty, onChange]);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, mb: 1, fontSize: "1.8rem" }}
        >
          Warranty Access
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "1.3rem" }}
        >
          Manage warranty access permissions for {selectedUser?.firstName}{" "}
          {selectedUser?.lastName}
        </Typography>
      </Box>

      {/* Warranty Access Controls */}
      <Paper elevation={1} sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{
            color: "#333",
            fontWeight: 700,
            mb: 2,
            fontSize: "1.4rem",
          }}
        >
          WARRANTY CLAIMS
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: warrantyEnabled ? "#2e7d32" : "#c62828",
            fontWeight: 600,
            mb: 2,
            fontSize: "1.35rem",
          }}
        >
          {warrantyEnabled ? "Yes" : "No"}
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={warrantyEnabled}
              onChange={(e) => setWarrantyEnabled(e.target.checked)}
            />
          }
          label="Allow Warranty Access"
          slotProps={{ typography: { sx: { fontSize: "1.35rem" } } }}
        />

        <Box sx={{ display: "flex", flexDirection: "column", pl: 2, mt: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={canSubmitWarranty}
                onChange={(e) => setCanSubmitWarranty(e.target.checked)}
                disabled={!warrantyEnabled}
              />
            }
            label="Can Submit Warranty Claims"
            slotProps={{ typography: { sx: { fontSize: "1.35rem" } } }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={canApproveRejectWarranty}
                onChange={(e) => setCanApproveRejectWarranty(e.target.checked)}
                disabled={!warrantyEnabled}
              />
            }
            label="Can Approve/Reject Warranty"
            slotProps={{ typography: { sx: { fontSize: "1.35rem" } } }}
          />
        </Box>

        {/* Save Button */}
        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const payload = {
                warrantyEnabled,
                canSubmitWarranty,
                canApproveRejectWarranty,
              };
              if (onSave) onSave(payload);
              else console.log("Save Warranty Settings", payload);
            }}
            sx={{ fontSize: "1.3rem" }}
          >
            Save Warranty Settings
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default WarrantyTab;
